import { api } from "./Axios";

const GeneralApi = {
  getConstants: () => {
    return api.get("constants").then((response: any) => response.data);
  },
};

export default GeneralApi;
